export default "__VITE_ASSET__CwHqm$KZ__"